import {
  Box,
  Select,
  Typography,
  Paper,
  Divider,
  MenuItem,
  Grid,
  Stack,
  IconButton,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import EditButton from "../../../assets/icons/EditButton.svg";

const ChecklistGracePeriodContent = () => {
  const navigate = useNavigate();
  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const [DepartmentName, setDepartmentName] = useState(
    departmentMasterData[0]?.id
  );

  const handleChangeDepartmentName = (event) => {
    setDepartmentName(event.target.value);
  };
  const ChecklistGracePeriodData = [
    {
      id: "1",
      name: "Daily",
    },
    {
      id: "2",
      name: "Weekly",
    },
    {
      id: "3",
      name: "Monthly",
    },
  ];

  return (
    <>
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Checklist Grace Period
              </Typography>
            </Box>
          </Box>
          <Box>
            <Select
              value={DepartmentName}
              onChange={handleChangeDepartmentName}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="18"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "4vh",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                backgroundColor: "#E5F1EB",
                border: "none",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none", 
                },
              }}
                InputLabelProps={{
                  shrink: true,
                }}
            >
              <MenuItem value="" disabled>
                Department Name
              </MenuItem>
              {departmentMasterData.map((row) => (
                <MenuItem value={row.id}>{row.name}</MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Grid container spacing={2} sx={{ padding: "10px 25px 25px 25px" }}>
          {ChecklistGracePeriodData?.map((row, index) => (
            <Grid item xs={12} key={row?.id}>
              <Stack direction="row" alignItems="center">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "#F3F6F9",
                    borderRadius: "10px",
                    padding: "10px 20px 10px 20px",
                    gap: "10px",
                  }}
                >
                  <Box>
                    <Typography
                      align="center"
                      sx={{
                        fontSize: "14px",
                        color: "#464E5F",
                        fontWeight: 600,
                      }}
                    >
                      {row?.name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Box>
                      <TextField
                        size="small"
                        disabled
                        placeholder="Enter Date and Time"
                        // onChange={filterBySearch}
                        sx={{
                          // mx: 2,
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #20724E",
                          borderRadius: "8px",
                          // "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          //   border: "1.5px solid #20724E",
                          //   borderRadius: "10px",
                          //   // backgroundColor: "#FFFFFF",
                          // },
                        }}
                      />
                    </Box>
                    <Box>
                      <IconButton
                      // onClick={() => handleDeleteChecklistType(row?.id)}
                      >
                        <img src={EditButton} width="30" height="30" />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </>
  );
};

export default ChecklistGracePeriodContent;
